// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"0":"openOnPhone","96":"vendors","636":"landing"}[chunkId] + "." + {"0":"c8a4ad45b32ebcbd4eaa","96":"26eef003ab3fae95a03d","636":"aeb694f8c8b85c8f88c5"}[chunkId] + ".bundle.js";
};